import { BILIARY_IMPRESSION, biliaryFindings } from "../groups/biliary";
import { option, type UsWorksheetDefinition } from "../us-fields";

export const US_BILIARY: UsWorksheetDefinition = {
  examType: "us_biliary",
  version: 1,
  indications: [
    option("ruq_pain", "RUQ pain"),
    option("abdominal_pain", "Abdominal pain"),
    option("right_flank_pain", "Right Flank pain"),
    option("vomiting", "Vomiting"),
    option("fever", "Fever"),
    option("jaundice", "Jaundice"),
    option("abnormal_lfts", "Abnormal LFTs"),
    option("pancreatitis", "Pancreatitis"),
    option("sepsis", "Sepsis"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "biliary_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: biliaryFindings("Other findings"),
    },
    {
      id: "biliary_impression",
      label: "Impression",
      role: "impression",
      fields: [BILIARY_IMPRESSION],
    },
  ],
  normalImpressions: [
    { sectionId: "biliary_impression", value: "normal_biliary" },
  ],
  billing: {
    codes: [
      { cpt: "76705", label: "Abdominal ultrasound, limited", preTick: true },
    ],
  },
};
